export const passwordRequirementsMessage =
  "La contraseña debe tener al menos 8 caracteres y un número.";

export const resetPasswordRequirementsMessage =
  "La contraseña debe tener al menos 8 caracteres, un número y un carácter especial.";

export function validatePasswordValues(values, options = {}) {
  const { requireSpecialCharacter = true } = options;
  const errors = {};
  const password = values.password ?? "";
  const passwordConfirm = values.passwordConfirm ?? "";
  const specialCharacterPattern = /[^A-Za-z0-9]/;

  if (!password) {
    errors.password = "La contraseña es obligatoria.";
  } else if (password.length < 8) {
    errors.password = "La contraseña debe tener al menos 8 caracteres.";
  } else if (!/\d/.test(password)) {
    errors.password = "La contraseña debe incluir al menos un número.";
  } else if (requireSpecialCharacter && !specialCharacterPattern.test(password)) {
    errors.password = "La contraseña debe incluir al menos un carácter especial.";
  }

  if (!passwordConfirm) {
    errors.passwordConfirm = "Repetí la contraseña.";
  } else if (passwordConfirm !== password) {
    errors.passwordConfirm = "Las contraseñas no coinciden.";
  }

  return errors;
}
